import React, { useEffect, useState } from 'react';
import {
  Badge,
  Col,
  Divider,
  Row,
  Tabs,
  Tag,
  notification,
  Timeline,
  Form,
  Typography,
  List,
  Drawer,
  Spin,
  Card,
} from 'antd';
import VirtualList from 'rc-virtual-list';

import { useParams } from 'react-router';
import { useQuery } from 'react-query';
import Managermodal from './components/managermodal';
import DF from '../../../DisplayFramework';
import {
  getCollectionByColid,
  getColpromiseByColid,
  runCollection,
} from 'services/collection';
import {
  GetListProcTaskByFilter,
  ViewProcTaskResponse,
} from 'services/workflow';
import { PageModalProps } from 'components/Page';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { useHistory } from 'react-router-dom';
import UtinaCard from 'components/UtinaCard';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import {
  ExclamationCircleOutlined,
  UpCircleFilled,
  ArrowLeftOutlined,
  PhoneFilled,
  HomeFilled,
  MailFilled,
  PrinterFilled,
} from '@ant-design/icons';
import { toCurrency } from 'utils/utils';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
import Button from 'components/Button';
import IPaymentschedule from 'icons/IPaymentschedule';
import IMail from 'icons/IMail';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import _ from 'lodash';
import ProcessFollowUp from 'components/ProcessFollowUp';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ModalControllerNV from 'components/ModalControllerNV';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import Flows from 'pages/ThirdParty/ThirdPartyDetail/Components/Flows';
import CommList from 'pages/Print/CommList';
import StatusHistoryPopover from 'components/StatusHistoryPopover';
import ColPromiseListModal from './components/colPromiseListModal';
import ColPromiseModal from './components/colPromiseModal';
import moment from 'moment';
import TaskModal from 'pages/workflow/TaskModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';

type CollectionDetailProps = PageModalProps & {
  colidp?: number;
};
const { TabPane } = Tabs;

const CollectionDetail = (props: CollectionDetailProps) => {
  const { id } = useParams<{
    id: string;
  }>();
  const colid = props.colidp ? props.colidp : Number(id);

  const SortProcessDataByDateDesc = (
    list: ViewProcTaskResponse[]
  ): ViewProcTaskResponse[] => {
    return list.sort(
      (date1: any, date2: any) =>
        new Date(date2.taskstatusdate).setHours(0, 0, 0, 0) -
        new Date(date1.taskstatusdate).setHours(0, 0, 0, 0)
    );
  };

  const {
    data: collection,
    isLoading: isColLoading,
    refetch: collectionrefetech,
    isFetching,
  } = useQuery(
    ['getCollectionByColid', colid],
    () =>
      getCollectionByColid({ colid: colid }).then((res) => {
        if (res.code === '403') {
          history.push('/403')
        }
        return res.data || {};
      }),
    {
      enabled: colid !== undefined,
    }
  );
  const {
    data: processData,
    refetch,
    isLoading,
  } = useQuery(
    ['GetListProcTaskByFilter', { colid }, isFetching],
    () =>
      GetListProcTaskByFilter({
        entity: 'COLLECTION',
        entityid: colid,
        filteringMode: '',
        holderid: '' as any,
        proccode: '',
        receiverRoleProfile: '',
        receiverType: '',
        receiverid: '' as any,
        senderid: '' as any,
        taskid: '' as any,
        taskstatus: '',
        userid: '' as any,
      }).then((res) => SortProcessDataByDateDesc(res.list)),
    { enabled: !!colid }
  );

  const { data: colPromise, refetch: refColpromise } = useQuery(
    ['getColpromise', isFetching],
    () =>
      getColpromiseByColid({ colid: colid, promtype: '' }).then(
        (res) => res.list || []
      ),
    { enabled: !!colid }
  );

  const [form] = useForm();
  const [visible360, setVisible360] = useState(false);
  const [visibleComm, setVisibleComm] = useState(false);
  const [visible, setVisible] = useState(false);

  const openDrawerSynthes = () => {
    setVisible(true);
  };

  const refreshCollection = (tpid: number) => {
    runCollection({
      tpidstart: tpid ?? 0,
      tpidend: tpid,
      duedate: dateToString(moment()),
      mgid: Number(localStorage.getItem('mgid')),
    }).then((res) => {
      if (res.code === '200') {
        notification.success({
          message: res.message,
          description: res.description,
        });
        refetch();
        collectionrefetech();
      } else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
    });
  };

  useEffect(() => {
    if (collection) {
      const daysSalesOutstanding: number =
        (collection.totalunpaid / collection.totalinvoicedamount) *
        moment(collection.lastinvoicedate).diff(
          moment(collection.firstinvoicedate),
          'days'
        );

      const turnover: number =
        collection.totalinvoicedamount / collection.totalunpaid;
      form.setFieldsValue({
        ...collection,
        last_action: _.find(processData)?.tasklabel,
        updatedat: moment(collection.updated_at).format('YYYY-MM-DD'),
        thirdparty: {
          tpid: collection.tpidclient,
          tpreference: collection.tpreference,
          tpname: collection.tpname,
        },
        totalBalance: collection.totaloutstanding + collection.totalunpaid,
        lastcolcommentDate: _.findLast(
          colPromise,
          (val) => val.promtype === 'COMMENT'
        )?.promstatusdate,
        lastpromtopayDate: _.findLast(
          colPromise,
          (val) => val.promtype !== 'COMMENT'
        )?.promstatusdate,
        lastcolcomment: _.findLast(
          colPromise,
          (val) => val.promtype === 'COMMENT'
        ),
        lastpromtopay: _.findLast(
          colPromise,
          (val) => val.promtype !== 'COMMENT'
        ),
        listcolcomment: colPromise?.filter((val) => val.promtype === 'COMMENT'),
        listpromtopay: colPromise?.filter((val) => val.promtype !== 'COMMENT'),
        daysSalesOutstanding: !isNaN(daysSalesOutstanding)
          ? Number(daysSalesOutstanding?.toFixed(3)) + '  Days'
          : 0,
        turnover: !isNaN(turnover) ? Number(turnover?.toFixed(3)) : 0,
      });
    }
  }, [collection, form, processData]);

  const history = useHistory();

  const columnsUnpaid: DataGridColDef<any>[] = [
    {
      dataIndex: 'cireference',
      width: '9%',
      render: (value, record) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a onClick={() => setVisible(true)}>{record.cireference}</a>
          )}
          modal={({ setVisible, visible }) => (
            <CIDetail
              ciid={Number(record.ciid)}
              onCancel={() => setVisible(false)}
              showAsModal
              visible={visible}
              isCreateCI={false}
              showButtons={false}
            />
          )}
        />
      ),
      fixed: 'left',
    },
    {
      dataIndex: 'cisorder',
      key: 'cisorder',
      width: '5%',
      fixed: 'left',
    },
    {
      dataIndex: 'cistatuslable',
      key: 'cistatuslable',
      width: '5%',
      fixed: 'left',
    },
    {
      dataIndex: 'ctreference',
      width: '8%',
      render: (value, record) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a onClick={() => setVisible(true)}>{record.ctreference}</a>
          )}
          modal={({ setVisible, visible }) => (
            <ProposalModal
              ctrid={record.ctrid}
              visible={visible}
              onCancel={() => setVisible(false)}
              onSuccess={() => setVisible(false)}
              title=""
              iscreate={false}
            />
          )}
        />
      ),
      fixed: 'left',
    },
    {
      dataIndex: 'cidocdate',
      width: '8%',
    },
    {
      dataIndex: 'civaluedate',
      width: '8%',
    },
    {
      dataIndex: 'cigrosstotal',
      width: '9%',
      render: (value, record) => toCurrency(value, record.currcode),
    },
    {
      dataIndex: 'cisunpaidamount',
      render: (value, record) => toCurrency(value, record.currcode),
      width: '10%',
    },
    {
      dataIndex: 'cipaymentmodelabel',
      width: '10%',
    },
    {
      dataIndex: 'cipaymentdate',
      width: '10%',
    },
    {
      dataIndex: 'cirejecteddate',
      width: '10%',
    },
    {
      dataIndex: 'reasonLabel',
      width: '10%',
    },

    {
      dataIndex: 'promdate',
      width: '10%',
    },
    {
      dataIndex: 'unpaidnbreofdays',
      width: '7%',
      fixed: 'right',
      render: (val) => <span style={{ fontWeight: 'bold' }}>{val}</span>,
    },
  ];

  const cardStyles = {
    fontSizeSmall: {
      fontSize: '13px',
    },
    fontSizeMedium: {
      fontSize: '13px',
    },
    fontSizeLarge: {
      fontSize: '16px',
    },
  };
  return (
    <DF.Provider pagcode="ColDetail" entity="COLLECTION" entityid={colid}>
      <Spin spinning={isColLoading}>
        <Form form={form} layout="horizontal">
          <div className="card-container Coldetail">
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                <Row gutter={2} justify="end">
                  <Col>
                    <Button
                      comcode="print"
                      icon={<PrinterFilled />}
                      onClick={(e) => setVisible360(true)}
                    />
                  </Col>
                  <Col>
                    <Button
                      comcode="view360"
                      icon={<IPaymentschedule />}
                      onClick={(e) => setVisible360(true)}
                    />
                  </Col>
                  <Col>
                    <Button
                      comcode="communication"
                      icon={<IMail />}
                      onClick={(e) => setVisibleComm(true)}
                    />
                  </Col>
                  <Col>
                    <TasksListPopover
                      entityId={colid}
                      entityName="COLLECTION"
                      entityReference={collection?.colreference}
                      title={
                        collection?.colreference + ' - ' + collection?.tpname
                      }
                      tpid={collection?.tpidclient}
                      onClose={() => {
                        collectionrefetech();
                        refColpromise();
                        refetch();
                      }}
                    >
                      <Button
                        icon={<IActions />}
                        size="middle"
                        comcode="actions"
                      />
                    </TasksListPopover>
                  </Col>
                </Row>
              }
            >
              <TabPane
                tab={
                  <>
                    <ArrowLeftOutlined
                      onClick={() => {
                        history.push('/collection');
                      }}
                    />
                    <GetLabel style={{ marginTop: 10 }} label="colDetail" />
                  </>
                }
                key="1"
              >
                <Row>
                  <UtinaCard
                    style={{ paddingTop: 0 }}
                    lg={24}
                    level={5}
                    noStyle
                    noBorder
                    comcode=""
                  >
                    <Row>
                      <UtinaCard
                        style={{ height: '100%' }}
                        level={5}
                        lg={11}
                        comcode="general_Information"
                        styleCard={{
                          paddingRight: 0,
                          paddingTop: '5px',
                          backgroundColor: 'rgba(240, 240, 240,0.3)',
                        }}
                      >
                        <Badge.Ribbon
                          style={{
                            width: '40%',
                            ...(window.innerWidth < 768
                              ? cardStyles.fontSizeSmall
                              : window.innerWidth < 1540
                              ? cardStyles.fontSizeMedium
                              : cardStyles.fontSizeLarge),
                          }}
                          text={
                            <div>
                              {collection ? (
                                <Typography.Text
                                  style={{ color: '#000', fontWeight: 500 }}
                                >
                                  <GetLabel label="days" /> &nbsp;:&nbsp;&nbsp;
                                  {collection?.unpaidnbreofdays}&nbsp; - max :{' '}
                                  {collection?.unpaidmaxnbdays}
                                </Typography.Text>
                              ) : (
                                ''
                              )}
                            </div>
                          }
                          color="#F6EAC2"
                        >
                          <Row style={{ marginTop: '10px' }}>
                            <Col span={14}>
                              <Row>
                                <FormInput
                                  col
                                  md={12}
                                  initialValue={2232}
                                  name="colreference"
                                  noMargin
                                  wrapperCol={{ span: 24 }}
                                  labelCol={{ span: 24 }}
                                >
                                  <Value />
                                </FormInput>
                                <StatusHistoryPopover
                                  objectid={colid ? colid : (null as any)}
                                  entity="COLLECTION"
                                >
                                  <Col span={12} style={{ marginTop: '8px' }}>
                                    {collection ? (
                                      <Tag
                                        color={
                                          collection.colstatus === 'INIT'
                                            ? 'green'
                                            : collection.colstatus === 'REC1'
                                            ? 'lime'
                                            : collection.colstatus === 'REC2'
                                            ? 'gold'
                                            : collection.colstatus === 'REC3'
                                            ? 'orange'
                                            : collection.colstatus === 'REC4'
                                            ? 'volcano'
                                            : 'red'
                                        }
                                        style={{
                                          fontSize: '15px',
                                        }}
                                      >
                                        <span style={{ textAlign: 'center' }}>
                                          {collection?.colstatusLabel}
                                        </span>
                                        <br />
                                        <span style={{ textAlign: 'center' }}>
                                          {collection?.colstatusdate}
                                        </span>
                                      </Tag>
                                    ) : (
                                      ''
                                    )}
                                  </Col>
                                </StatusHistoryPopover>
                              </Row>
                            </Col>
                          </Row>
                        </Badge.Ribbon>
                        <Badge.Ribbon
                          style={{
                            width: '40%',
                            ...(window.innerWidth < 768
                              ? cardStyles.fontSizeSmall
                              : window.innerWidth < 1540
                              ? cardStyles.fontSizeMedium
                              : cardStyles.fontSizeLarge),
                          }}
                          text={
                            <div>
                              <Typography.Text
                                style={{ color: '#000', fontWeight: 500 }}
                              >
                                <GetLabel label="unpaid" /> &nbsp;:&nbsp;&nbsp;
                                {toCurrency(
                                  collection?.totalunpaid,
                                  collection?.currcode
                                )}
                                &nbsp; - max :{' '}
                                {toCurrency(
                                  collection?.unpaidmaxamount,
                                  collection?.currcode
                                )}
                              </Typography.Text>
                            </div>
                          }
                          color="#FDD7C2"
                        >
                          <Row>
                            <Col span={14}>
                              <Row>
                                <FormInput
                                  noMargin
                                  col
                                  md={12}
                                  name="colstartdate"
                                  wrapperCol={{ span: 24 }}
                                  labelCol={{ span: 24 }}
                                >
                                  <Value />
                                </FormInput>
                                <FormInput
                                  noMargin
                                  col
                                  md={12}
                                  name="colenddate"
                                  wrapperCol={{ span: 24 }}
                                  labelCol={{ span: 24 }}
                                >
                                  <Value />
                                </FormInput>
                              </Row>
                            </Col>
                          </Row>
                        </Badge.Ribbon>

                        <Badge.Ribbon
                          style={{
                            width: '40%',
                            ...(window.innerWidth < 768
                              ? cardStyles.fontSizeSmall
                              : window.innerWidth < 1540
                              ? cardStyles.fontSizeMedium
                              : cardStyles.fontSizeLarge),
                          }}
                          text={
                            <div>
                              <Typography.Text
                                style={{ color: '#000', fontWeight: 500 }}
                              >
                                <GetLabel label="outstanding" />{' '}
                                &nbsp;:&nbsp;&nbsp;
                                {toCurrency(
                                  collection?.totaloutstanding,
                                  collection?.currcode
                                )}
                                &nbsp;
                              </Typography.Text>
                            </div>
                          }
                          color="#B7CFB7"
                        >
                          <Row>
                            <Col span={14}>
                              <Row>
                                <Form.Item
                                  shouldUpdate={shouldUpdateCompare(
                                    'colmanagerName'
                                  )}
                                  noStyle
                                >
                                  {({ getFieldValue }) => (
                                    <FormInput
                                      noMargin
                                      col
                                      md={12}
                                      name="colmanagerName"
                                      wrapperCol={{ span: 24 }}
                                      labelCol={{ span: 24 }}
                                    >
                                      <Managermodal
                                        colid={colid}
                                        managername={getFieldValue(
                                          'colmanagerName'
                                        )}
                                      />
                                    </FormInput>
                                  )}
                                </Form.Item>

                                <FormInput
                                  noMargin
                                  col
                                  md={12}
                                  name="colassigndate"
                                  wrapperCol={{ span: 24 }}
                                  labelCol={{ span: 24 }}
                                >
                                  <Value />
                                </FormInput>
                              </Row>
                            </Col>
                          </Row>
                        </Badge.Ribbon>

                        <Divider />

                        <Row gutter={[8, 16]}>
                          <FormInput
                            noMargin
                            col
                            md={9}
                            name="last_action"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value />
                          </FormInput>
                          <FormInput
                            noMargin
                            col
                            md={8}
                            name="updatedat"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value />
                          </FormInput>
                          <Col span={5}>
                            <Button
                              type="primary"
                              comcode="refresh"
                              style={{ width: '100%', float: 'left' }}
                              onClick={() =>
                                refreshCollection(collection?.tpidclient ?? 0)
                              }
                            />
                          </Col>
                        </Row>
                        <Divider style={{ margin: 0 }} />
                        <Row>
                          <Col span={9}>
                            <Form.Item shouldUpdate style={{ margin: 7 }}>
                              {({ getFieldValue }) => (
                                <Row>
                                  <GetLabel label="lastpromtopayDate" />
                                  :&nbsp;&nbsp;
                                  <ModalControllerNV
                                    modal={({ setVisible, visible }) => (
                                      <ColPromiseModal
                                        onClose={() => setVisible(false)}
                                        visible={visible}
                                        type="PROM"
                                        data={getFieldValue('lastpromtopay')}
                                      />
                                    )}
                                    content={({ setVisible, visible }) => (
                                      <a onClick={() => setVisible(true)}>
                                        {getFieldValue('lastpromtopayDate')}
                                      </a>
                                    )}
                                  />
                                </Row>
                              )}
                            </Form.Item>
                          </Col>

                          <Form.Item
                            shouldUpdate={shouldUpdateCompare('listcolcomment')}
                            style={{ margin: 7 }}
                          >
                            {({ getFieldValue }) => (
                              <ModalControllerNV
                                modal={({ setVisible, visible }) => (
                                  <ColPromiseListModal
                                    onClose={() => setVisible(false)}
                                    visible={visible}
                                    type="PROM"
                                    data={getFieldValue('listpromtopay')}
                                  />
                                )}
                                content={({ setVisible, visible }) => (
                                  <a onClick={() => setVisible(true)}>
                                    See History
                                  </a>
                                )}
                              />
                            )}
                          </Form.Item>
                        </Row>
                        <Divider style={{ margin: 0 }} />
                        <Row>
                          <Col span={9}>
                            <Form.Item shouldUpdate style={{ margin: 7 }}>
                              {({ getFieldValue }) => (
                                <Row>
                                  <GetLabel label="lastcolcommentDate" />
                                  :&nbsp;&nbsp;
                                  <ModalControllerNV
                                    modal={({ setVisible, visible }) => (
                                      <ColPromiseModal
                                        onClose={() => setVisible(false)}
                                        visible={visible}
                                        type="COMM"
                                        data={getFieldValue('lastcolcomment')}
                                      />
                                    )}
                                    content={({ setVisible, visible }) => (
                                      <a onClick={() => setVisible(true)}>
                                        {getFieldValue('lastcolcommentDate')}
                                      </a>
                                    )}
                                  />
                                </Row>
                              )}
                            </Form.Item>
                          </Col>

                          <Form.Item
                            shouldUpdate={shouldUpdateCompare('listcolcomment')}
                            style={{ margin: 7 }}
                          >
                            {({ getFieldValue }) => (
                              <ModalControllerNV
                                modal={({ setVisible, visible }) => (
                                  <ColPromiseListModal
                                    onClose={() => setVisible(false)}
                                    visible={visible}
                                    type="COMM"
                                    data={getFieldValue('listcolcomment')}
                                  />
                                )}
                                content={({ setVisible, visible }) => (
                                  <a onClick={() => setVisible(true)}>
                                    See History
                                  </a>
                                )}
                              />
                            )}
                          </Form.Item>
                        </Row>
                      </UtinaCard>
                      <UtinaCard
                        level={5}
                        lg={6}
                        comcode="personalInfo"
                        styleCard={{
                          backgroundColor: 'rgba(240, 240, 240,0.3)',
                        }}
                      >
                        <FormInput noMargin col md={24} name="thirdparty">
                          <ThirdPartyInput display />
                        </FormInput>

                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('tpidclient')}
                          noStyle
                        >
                          {({ getFieldValue }) => (
                            <FormInput
                              icon={
                                <HomeFilled
                                  style={{ color: 'red', fontSize: 15 }}
                                />
                              }
                              noMargin
                              col
                              md={24}
                              name="tpadrid"
                            >
                              <AddresseListSelect
                                params={{ tpid: getFieldValue('tpidclient') }}
                                display
                              />
                            </FormInput>
                          )}
                        </Form.Item>
                        <FormInput
                          noMargin
                          icon={
                            <PhoneFilled
                              style={{ color: '#008F41', fontSize: 15 }}
                            />
                          }
                          col
                          md={24}
                          name="tptel1"
                        >
                          <Value />
                        </FormInput>
                        <FormInput
                          icon={
                            <MailFilled
                              style={{ color: 'black', fontSize: 15 }}
                            />
                          }
                          noMargin
                          col
                          md={24}
                          name="tpemail"
                        >
                          <Value />
                        </FormInput>

                        <FormInput
                          noMargin
                          col
                          md={24}
                          name="tpsalestatuslabel"
                        >
                          <Value />
                        </FormInput>

                        {/* <FormInput noMargin col md={24} name="totalunpaid">
                        <Value formatter={(val) => toCurrency(val, localStorage.getItem('currcode') ?? '')} />
                      </FormInput> */}
                        <Row>
                          <FormInput
                            style={{ color: 'red' }}
                            noMargin
                            col
                            md={12}
                            name="totalBalance"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value
                              formatter={(val) =>
                                toCurrency(val, collection?.currcode)
                              }
                            />
                          </FormInput>

                          <FormInput
                            style={{ color: 'red' }}
                            noMargin
                            col
                            md={12}
                            name="totalinvoicedamount"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value
                              formatter={(val) =>
                                toCurrency(val, collection?.currcode)
                              }
                            />
                          </FormInput>
                        </Row>

                        <Row>
                          <FormInput
                            style={{ color: 'red' }}
                            noMargin
                            col
                            md={12}
                            name="firstinvoicedate"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value />
                          </FormInput>

                          <FormInput
                            style={{ color: 'red' }}
                            noMargin
                            col
                            md={12}
                            name="lastinvoicedate"
                            wrapperCol={{ span: 24 }}
                            labelCol={{ span: 24 }}
                          >
                            <Value />
                          </FormInput>

                          <FormInput
                            labelstyle={{ fontWeight: 'bold', color: 'white' }}
                            noMargin
                            col
                            md={24}
                            name="daysSalesOutstanding"
                            labelAlign="left"
                            colStyle={{
                              border: '1px solid',
                              fontSize: '14px',
                              top: '8px',
                              height: '49px',
                              padding: '0 8px',
                              color: '#fff',
                              backgroundColor: '#243882',
                              borderRadius: ' 7px',
                            }}
                            wrapperCol={{ span: 11 }}
                            labelCol={{ span: 13 }}
                            style={{ color: 'white', fontWeight: 'bold' }}
                          >
                            <Value />
                          </FormInput>

                          <FormInput
                            labelstyle={{ fontWeight: 'bold', color: 'white' }}
                            noMargin
                            col
                            md={24}
                            name="turnover"
                            labelAlign="left"
                            wrapperCol={{ span: 11 }}
                            labelCol={{ span: 13 }}
                            colStyle={{
                              border: '1px solid',
                              fontSize: '14px',
                              top: '8px',
                              height: '49px',
                              padding: '0 8px',
                              color: '#fff',
                              backgroundColor: '#5777d4',
                              borderRadius: ' 7px',
                              marginTop: 8,
                            }}
                            style={{ color: 'white', fontWeight: 'bold' }}
                          >
                            <Value />
                          </FormInput>
                        </Row>
                      </UtinaCard>
                      <UtinaCard lg={6} level={5} comcode="TaskList">
                        <List loading={isLoading}>
                          <VirtualList
                            data={processData ?? []}
                            height={400}
                            itemKey="id"
                            fullHeight
                          >
                            {(item: any, index: any) => (
                              <List.Item key={item.id}>
                                <Timeline.Item
                                  key={index}
                                  style={{ fontSize: 15, marginLeft: '5px' }}
                                  dot={
                                    item.taskstatus === 'CLOSED' ? (
                                      <UpCircleFilled
                                        color="green"
                                        style={{
                                          fontSize: 18,
                                          color: '#00A896',
                                        }}
                                      />
                                    ) : (
                                      <ExclamationCircleOutlined
                                        color="green"
                                        style={{
                                          fontSize: 18,
                                          color: '#00A896',
                                        }}
                                      />
                                    )
                                  }
                                  color="green"
                                >
                                  {item?.taskstatus === 'INIT' ? (
                                    <ModalControllerNV
                                      content={({ setVisible, visible }) => (
                                        <a
                                          onClick={() => {
                                            setVisible(true);
                                          }}
                                        >
                                          {item?.tasklabel +
                                            ' ' +
                                            moment(item?.taskstatusdate).format(
                                              'YYYY-MM-DD'
                                            )}
                                        </a>
                                      )}
                                      modal={({ setVisible, visible }) => (
                                        <TaskModal
                                          random={Math.round(
                                            _.random(10000000)
                                          )}
                                          entityId={item?.objectid}
                                          entity={item?.procmodule}
                                          entityName={
                                            item?.tasklabel +
                                            ' - ' +
                                            item?.procmodule +
                                            ' - ' +
                                            item?.objectreference
                                          }
                                          onCancel={() => setVisible(false)}
                                          onSuccess={refetch}
                                          task={{
                                            funcode: item?.funcode,
                                            id: item?.id,
                                            lancode: item?.lancode,
                                            proccode: item?.proccode,
                                            procmodule: item?.procmodule,
                                            procrule: item?.procrule,
                                            serviceurl: item?.serviceurl,
                                            taskid: item?.taskid,
                                            tasklabel: item?.tasklabel,
                                            taskrule: item?.taskrule,
                                            tasktriggermode:
                                              item?.tasktriggermode,
                                            tasktype: item?.tasktype,
                                            subentity: item?.subentity,
                                            subentityid: item?.subentityid,
                                          }}
                                          visible={visible}
                                        />
                                      )}
                                    />
                                  ) : (
                                    item?.tasklabel +
                                    ' ' +
                                    moment(item?.taskstatusdate).format(
                                      'YYYY-MM-DD'
                                    )
                                  )}
                                </Timeline.Item>
                              </List.Item>
                            )}
                          </VirtualList>
                        </List>
                      </UtinaCard>
                      <UtinaCard
                        lg={24}
                        level={5}
                        noStyle
                        noBorder
                        comcode="TaskLdist"
                      >
                        <div style={{ padding: '5px 20px' }}>
                          <DataGrid
                            titleComcode="liste_unpaid"
                            columns={columnsUnpaid}
                            dataSource={collection?.colunpaidList || []}
                            rowKey="cunpid"
                            pagination={{ pageSize: 7 }}
                            scroll={{ x: 2200, y: 400 }}
                            hideExtraAction
                            hideFilters
                          />
                        </div>
                      </UtinaCard>
                    </Row>
                  </UtinaCard>
                </Row>
              </TabPane>
              <TabPane
                tab={
                  <GetLabel style={{ marginTop: 10 }} label="entityFollowUp" />
                }
                key="2"
              >
                <Card>
                  <ProcessFollowUp
                    entity="COLLECTION"
                    entityid={colid}
                    entityReference={collection?.colreference ?? ''}
                    refetech={isFetching}
                  ></ProcessFollowUp>
                </Card>
              </TabPane>
            </Tabs>
          </div>
        </Form>
        <Drawer
          title="View360"
          width="80%"
          placement="right"
          onClose={() => setVisible360(false)}
          visible={visible360}
          headerStyle={{ backgroundColor: '#00a896' }}
          bodyStyle={{ paddingBottom: 10, alignContent: 'center' }}
          drawerStyle={{
            padding: '10px 16px 10px 10px',
            margin: '10px 16px 10px 10px',
          }}
        >
          <Flows
            tpid={collection?.tpidclient ?? (null as any)}
            form={form}
            currcode={collection?.currcode}
          />
        </Drawer>
        <Drawer
          title="Communication"
          width="80%"
          placement="right"
          onClose={() => setVisibleComm(false)}
          visible={visibleComm}
          headerStyle={{ backgroundColor: '#00a896' }}
          bodyStyle={{ paddingBottom: 10, alignContent: 'center' }}
          drawerStyle={{
            padding: '10px 16px 10px 10px',
            margin: '10px 16px 10px 10px',
          }}
        >
          <CommList tpid={Number(collection?.tpidclient)} onlyCollection />
        </Drawer>
      </Spin>
    </DF.Provider>
  );
};

export default CollectionDetail;
